import { OutlinedInput, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useCallback, useRef, useState } from "react";
import { ChromePicker } from "react-color";
import { IProductParams } from "../../../model";
import { appLogger } from "../../../utils";
import useClickOutside from "./useClickOutside";

const BrandingFontSizeField = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "BrandingFontSizeField",
      component: "add-product",
      fileName: "BrandingFontSizeField.tsx",
      prpos: props,
    },
  });

  const { productParams, setProductParams, field, fieldValue } = props;
  const handleInputChange = (event: any) => {
    const fieldValue = event.target.value;
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        if (!temp.products[0].feedbackAgentSettings.branding) {
          temp.products[0].feedbackAgentSettings.branding = {};
        }
        if (field == "Font Size") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-editor-font-size"
          ] = fieldValue;
          setProductParams(temp);
        }
      }
    }
  };

  return (
    <>
      {/* ******************Form Appreance******************************** */}

      <FormControl className="custom-select" fullWidth>
        <InputLabel>Font Size </InputLabel>
        <Select
          id={`${field}`}
          name={`select_fontStyle`}
          value={fieldValue}
          onChange={(event) => {
            handleInputChange(event);
          }}
        >
          {Array.from(Array(20)).map((_, i) => (
            <MenuItem key={1} value={i + 1 + "px"}>
              {i + 1}px
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {/* *****************Form Appreance************************************** */}
    </>
  );
};

export default BrandingFontSizeField;
